import { Button, TextField } from "@hellocarbo/lasagne";
import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";

import useSignupSteps from "@/hooks/useSignupSteps";

import Template from "./Template";

const PhoneNumberStep = ({
  phoneNumber,
  setPhoneNumber,
}: {
  phoneNumber: string;
  setPhoneNumber: Dispatch<SetStateAction<string>>;
}) => {
  const { t } = useTranslation(["common", "signUp"]);
  const { goToNextStep } = useSignupSteps();

  const [hasError, setHasError] = useState(false);

  const handleContinue = () => {
    // naive client side phone number format validation
    const regex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/gim;

    if (regex.test(phoneNumber)) {
      goToNextStep();
    } else {
      setHasError(true);
    }
  };

  const handleSkip = () => {
    goToNextStep();
  };

  return (
    <Template
      title={t("signUp:phoneNumber.title")}
      buttonText={t("continue")}
      onClick={handleContinue}
      secondaryAction={
        <Button shape="link" onClick={handleSkip} fullWidth>
          {t("signUp:skip")}
        </Button>
      }
    >
      <div className="space-y-md">
        <div>
          <TextField
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setPhoneNumber(e.target.value)
            }
            type="phone"
            name="phoneNumber"
            value={phoneNumber}
            label={t("signUp:phoneNumber.label")}
            placeholder={t("signUp:phoneNumber.placeholder")}
            error={hasError ? t("signUp:phoneNumber.error") : undefined}
            onFocus={() => setHasError(false)}
            fullWidth
          />
        </div>
      </div>
    </Template>
  );
};

export default PhoneNumberStep;
